@if (required) {
  <span class="ps-1">*</span>
}
